import { Link } from 'react-router'
import styles from './Logo.module.css'

export interface LogoProps {
  to: string
  src: string
  alt: string
}

export function Logo({ to, src, alt }: LogoProps) {
  return (
    <div className="mb-lg">
      <Link to={to}>
        <img className={styles.logoImage} src={src} alt={alt} />
      </Link>
    </div>
  )
}
